import axios from "axios";
//import { Auth } from "aws-amplify";

const API = axios.create({
  baseURL: "/",
});

export default API;
